import { render, staticRenderFns } from "./Reminders.vue?vue&type=template&id=a31387b6&scoped=true&lang=html"
import script from "./Reminders.vue?vue&type=script&lang=js"
export * from "./Reminders.vue?vue&type=script&lang=js"
import style0 from "./Reminders.vue?vue&type=style&index=0&id=a31387b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31387b6",
  null
  
)

export default component.exports